import React from "react";
import Toast from "./Toast";
import { useTransition } from "react-spring";
import { Container } from "./styles";
import { ToastMessage } from "../../../Hooks/toast";

interface ToastContainerProps {
  messages: ToastMessage[];
}

const ToastContainer: React.FC<ToastContainerProps> = ({ messages }) => {
  const messageTransition = useTransition(messages, {
    keys: (item) => item.id,
    from: { right: "-60%", opacity: 0 },
    enter: { right: "0%", opacity: 1 },
    leave: { right: "-60%", opacity: 0 },
  });

  return (
    <Container>
      {messageTransition((props, item, keys) => (
        <Toast key={keys.key} style={props} message={item}></Toast>
      ))}
    </Container>
  );
};

export default ToastContainer;
